module.exports = __webpack_public_path__ + "6c4a0dbc/img/google.68f3823e.svg";